module.exports = __webpack_public_path__ + "static/britneysWeight-34358e415c8d05bedc6fc5d61439375e.jpg";